import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { NAME_SPACE } from 'i18n';
import HorizontalStepper from 'shared/HorizontalStepper/HorizontalStepper';
import { ReadDefectiveTagsStep, ReadDefectiveTagsStepSummary } from './Steps';

export function StepperDefectiveTagsRequest({ requestId, onSubmit, onCancel, errors, isBusy }) {
  const { t } = useTranslation(NAME_SPACE.READER_REQUESTS);

  async function handleNext(currentStep) {
    if (currentStep === 2) {
      await onSubmit(requestId);
    }
  }

  function handleCancel(currentStep) {
    if (currentStep < 0) {
      onCancel && onCancel();
    }
  }

  return (
    <HorizontalStepper
      steps={[
        t('defectiveTagsReplacement.step01.title'),
        t('defectiveTagsReplacement.step02.title'),
        t('defectiveTagsReplacement.step03.title')
      ]}
      stepsContent={[
        <ReadDefectiveTagsStep key={0} description={t('defectiveTagsReplacement.step01.description')} />,
        <ReadDefectiveTagsStep key={1} description={t('defectiveTagsReplacement.step02.description')} />,
        <ReadDefectiveTagsStepSummary
          key={2}
          description={t('defectiveTagsReplacement.step03.description')}
          errors={errors}
        />
      ]}
      onPressNext={handleNext}
      onPressBack={handleCancel}
      disableActions={isBusy}
    />
  );
}

StepperDefectiveTagsRequest.propTypes = {
  requestId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isBusy: PropTypes.bool
};
